import React, { PureComponent } from 'react';
import Radium from 'radium';
import { Field } from 'redux-form';
import { any, string, bool, func } from 'prop-types';
import { DeleteForever } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { required, phoneLength } from '@widergy/web-utils/lib/validate';
import { onlyNumbers } from '@widergy/web-utils/lib/normalize';
import { FIELD_PHONE } from '@widergy/utilitygo-forms-web/dist/constants/fieldTypes';
import { UTTextInput, UTPhoneInput } from '@widergy/energy-ui';

import UTCheckbox from 'app/components/UTCheckbox';
import UTSelectInput from 'app/components/UTSelectInput';
import { CARRIERS } from 'constants/common';
import { FieldsConfig } from 'app/components/UTForm/constants';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';

import Header from '../Header';

import styles from './styles';

const { usePhoneFields } = appConfig.userDataManagement;

const ComponentInput = usePhoneFields ? UTPhoneInput : UTTextInput;

const phoneProps = FieldsConfig()[FIELD_PHONE];

// This is a temporally patch, we need adapt this view later to use utilitygo-forms-web package
const PhoneInput = props => <ComponentInput onChange={props.input.onChange} {...props} />; // eslint-disable-line react/prop-types

class Phones extends PureComponent {
  validateCarrier = [required(message('Translation:fieldRequired'))];

  validatePhone =
    (this.props.isMobile && appConfig.userDataManagement.cellPhoneRequired) ||
    (!this.props.isMobile && appConfig.userDataManagement.landlineRequired)
      ? [
          required(message('Translation:fieldRequired')),
          phoneLength(10, message('Validations:invalidFormat'))
        ]
      : [phoneLength(10, message('Validations:invalidFormat'))];

  handleAddPhone = () => this.props.fields.push({ default: false });

  handleDeletePhone = index => this.props.fields.remove(index);

  handleSetDefault = index => this.props.onSetDefaultPhone(this.props.fields.get(index).number);

  isDefault = index => this.props.fields.get(index).number === this.props.defaultPhoneNumber;

  render() {
    return (
      <React.Fragment>
        <Header
          title={this.props.isMobile ? 'Teléfonos Celulares' : 'Telefonos Fijos'}
          onAdd={this.handleAddPhone}
          disabled={this.props.fields.length === appConfig.userDataManagement.MAX_PHONES}
        />
        {this.props.fields.map((phone, index) => (
          <div key={phone} style={styles.container}>
            {this.props.isMobile && appConfig.userDataManagement.useCarrier && (
              <Field
                name={`${phone}.carrier`}
                placeholder={message('Configuration:carrier')}
                component={UTSelectInput}
                keyProp="id"
                labelKey="name"
                valueKey="value"
                validate={this.validateCarrier}
                options={CARRIERS}
              />
            )}
            <div style={styles.phone}>
              <Field
                name={`${phone}.number`}
                placeholder={
                  usePhoneFields ? message('Configuration:phone') : message('Configuration:phoneWithoutZero')
                }
                label={message('Configuration:phone')}
                field={{
                  configuration: {
                    area_code_label: message('PhoneInput:areaCodeLabel'),
                    area_code_placeholder: message('PhoneInput:areaCodePlaceholder')
                  }
                }}
                component={PhoneInput}
                format={!usePhoneFields && onlyNumbers}
                normalize={!usePhoneFields && onlyNumbers}
                validate={this.validatePhone}
                {...phoneProps}
              />
              {appConfig.userDataManagement.mayDeletePhones && (
                <IconButton style={styles.deleteButton} onClick={() => this.handleDeletePhone(index)}>
                  <DeleteForever />
                </IconButton>
              )}
            </div>
            {appConfig.userDataManagement.useDefaultPhone && (
              <UTCheckbox
                style={styles.checkbox}
                label={message('Configuration:primaryPhone')}
                onChange={() => this.handleSetDefault(index)}
                value={this.isDefault(index)}
              />
            )}
          </div>
        ))}
      </React.Fragment>
    );
  }
}

Phones.propTypes = {
  fields: any, // eslint-disable-line react/forbid-prop-types
  isMobile: bool,
  onSetDefaultPhone: func.isRequired,
  defaultPhoneNumber: string
};

export default Radium(Phones);
